"use strict";
var scanForPdfNotes = require("./pdfViewer.js");
require("bootstrap");
require("locale_kl");
var moment = require("moment");

var localization = window.Localization;

initVis();

function initVis() {
    $(function () {
        getDagsorden();
    });
}

function initGetLinks(dagsordenId) {
    var setLinks = function (e) {
        if (e.type === "keydown" && !enterOrSpacePressed(e)) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();

        var id = $(this).data("id");
        var type = $(this).data("type");

        if (!id) return;

        switch (type) {
            case "kopier_punkt":
                showCopyUrlDialog(id);
                return;
            case "send_punkt":
                showSendToFriendDialog(id);
                return;
        }

        var url = `${location.origin}/vis/pdf/${type}/${id}?redirectDirectlyToPdf=${isIDevice()}`;

        url = url.replace("{uuid}", dagsordenId);
        window.open(url, "_blank");
    };

    var dataType = $("[data-type]");
    dataType.off("click").on("click", setLinks);
    dataType.off("keydown").on("keydown", setLinks);
}

function enterOrSpacePressed(event) {
    return event.which === 13 || event.which === 32;
}

function showCopyUrlDialog(punktId) {
    var url = generateUrlForPunkt(punktId);
    var dialog = $("#kopier_dialog");
    var textfieldJQueryElement = dialog.find("[data-type=url_field]");
    textfieldJQueryElement.on("focus", function (e) {
        textfield.select();
    });
    dialog.on('hide.bs.modal', function () {
        $('[data-id=' + punktId + ']').focus();
    });
    var textfield = textfieldJQueryElement[0];
    textfield.value = url;
    dialog.modal('show');
    textfield.select();
}

function generateUrlForPunkt(id) {
    var location = document.location;
    var url = location.origin + location.pathname;
    var reader = new QueryReader(location.hash, window.location.search);
    reader.setPunktId(id);
    url = url + reader.getQueryString();
    return url;
}

function showSendToFriendDialog(punktId) {
    var dialog = $("#send_dialog");
    var sendbutton = dialog.find("#send_dialog_button");
    var location = window.location;
    var url = location.origin + location.pathname + "/SendMail";

    var handler = new SendEmailDialogHandler(url, punktId, dialog, sendbutton, new QueryReader(window.location.hash, window.location.search), grecaptcha);
    handler.show();

    sendbutton.off().on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        handler.fire(function () {
            Alert.show(localization.getText("Meeting_Message_Sent"));
        }, function (message) {
            Alert.show(localization.getText("Meeting_Message_Not_Sent") + " '" + message + "'");
        });
    })
}

var Alert = {
    show: function (txt) {
        var dialog = $("#info_dialog");
        dialog.find("[data-type=content]").text(txt);
        dialog.modal('show');
    }
};

function isIDevice() {
    return /i(Phone|Pod|Pad)|MacIntel/i.test(navigator.platform);
}

function getDagsorden() {
    var reader = new QueryReader(window.location.hash, window.location.search);
    var searchTerm = reader.getSearchTerm();
    var dagsordenId = reader.getDagsordenId();
    var url = `/api/agenda/dagsorden/${dagsordenId}`;

    if (searchTerm) {
        url += `?fritekst=${searchTerm}`;
    }

    $("#spinner-dagsorden .spinner").show();
    $.ajax({
        url: url, type: "GET", async: true, dataType: "json", success: function (data) {
            setPageTitle(data);
            renderDagsorden(data, reader);
            initExpand();
            initGetLinks(dagsordenId);
            $("#spinner-dagsorden .spinner").hide();
        }, error: function (error) {
            $("#spinner-dagsorden .spinner").hide();
            $("#supplerende-fejlbesked").html(error.responseJSON);
            $('#errorDialog').modal('show');
        }
    });
}

var setPageTitle = function (dagsorden) {
    var title = dagsorden.Udvalg.Navn;
    if (dagsorden.Moede.Sted) {
        title += " - " + dagsorden.Moede.Sted;
    }

    document.title = title;
};

function assertMeetingDescription(description) {
    if (!!description) {
        document.querySelector("[data-description-container]").hidden = false;
        document.querySelector("[data-meeting-description]").innerHTML = description;
    }
}

function renderDagsorden(dagsorden, reader) {
    const searchTerm = reader.getSearchTerm();
    const sharedItemId = reader.getPunktId();

    const meetingStatus = dagsorden.Moede.Afsluttet ? localization.getText("Localization_js_Meeting_Minutes") : localization.getText("Localization_js_Agenda");
    const meetingFullStatus = dagsorden.Moede.IsSupplementaryAgenda ? `${meetingStatus} (${localization.getText("Localization_js_Supplementary_Agenda")})` : meetingStatus;

    $("#hentHeledagsorden").val((dagsorden.Moede.Afsluttet ? localization.getText("Meeting_Get_Minutes") : localization.getText("Meeting-Download_Agenda")));

    var language = $("#locale").val();
    $(".title .dato").html(`${meetingFullStatus} ${moment(dagsorden.Moede.Dato).locale(language).format(localization.getText("Meeting_DateTime_Format"))}`);
    $(".dagsordeninfo .dato").html(moment(dagsorden.Moede.Dato).locale(language).format(localization.getText("Meeting_Full_DateTime_Format")));

    $(".udvalg").html(dagsorden.Udvalg.Navn);
    $(".sted").html(dagsorden.Moede.Sted);

    assertMeetingDescription(dagsorden.Moede.Description)

    modellerMoededeltagere(dagsorden.Moede.Moededeltagere, dagsorden.Dagsordenpunkter);

    var dagsordenpunktTemplate = "";

    $.each(dagsorden.Dagsordenpunkter, function (i, dagsordenpunkt) {
        var titel = localization.getText("Meeting_Closed_Item");

        if (dagsordenpunkt.Navn) {
            var highlighting = highlightWithSearchParameters(searchTerm, dagsordenpunkt.Navn);
            titel = highlighting.newHtml;
        }

        var felter = modellerFelter(dagsordenpunkt.Felter, dagsordenpunkt.Ressourcer, searchTerm);

        dagsordenpunktTemplate += "<tr class=\"punktrow\" id='punktrow_" + dagsordenpunkt.Id + "'>";

        var punktNr = "<td class='text-center punkt-tabel'>" + "<span class='label label-default'>" + dagsordenpunkt.Punktnummer + "</span>" + "</td>";

        var overskriftOgdetails = "<td class='punkt-tabel'><button class='overskrift-btn' role='button' aria-expanded='false' aria-controls='details" + i + "'>" + "<h2 class='overskrift text-left' id='overskrift" + i + " 'tabindex=0>" + titel + "</h2>" + "</button>" + "<div class='details' id='details" + i + "'>" + (dagsordenpunkt.SagsNummer != null ? "<span class='sagsnummer'>" + dagsordenpunkt.SagsNummer + "</span>" : "") + "<div class='punkt'>" + felter.FelterHtml + "</div>" + modellerAbsentAttendees(dagsordenpunkt.ExternalAgendaItemAttendees) + modellerCancelledAttendees(dagsordenpunkt.ExternalAgendaItemAttendees) + modellerBilag(dagsordenpunkt.Bilag, titel) + modellerLydfil(dagsordenpunkt.Lydfiler) + "</div>" + "</td>";

        var downloadAsPdfAriaLabel = localization.getText("Localization_js_Download_As_Pdf_AriaLabel").replace("@@itemnumber", dagsordenpunkt.Punktnummer);
        var copyLink = localization.getText("Meeting_Copy_Link");
        var copyLinkAriaLabel = localization.getText("Meeting_Copy_Link_AriaLabel").replace("@@itemnumber", dagsordenpunkt.Punktnummer);

        var dropdownOgExpand = "<td class='punkt-tabel'>" + "<div class='row'>" + "<div class='col-md-9'><span class='lydfiler-og-bilag'>" + modellerLydfilerOgBilagOverskrift(dagsordenpunkt.Lydfiler, dagsordenpunkt.Bilag) + "</span></div>" + "<div class='col-md-3'>" + "<span class='dropdown'>" + "<button class='glyphicon glyphicon-option-horizontal dropdown-toggle' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false' " + "aria-label='" + localization.getText("Meeting_Menu_Item") + " " + titel + "'></button>" + "<ul class='dropdown-menu dagsordenpunktdropdown' role='menu'>" + "<li><a class='dropdown-item' href='#' role='menuitem' aria-label='" + downloadAsPdfAriaLabel + "' data-id='" + dagsordenpunkt.Id + "' data-type='dagsordenpunkt'>" + localization.getText("Localization_js_Download_As_Pdf") + "</a></li >" + "<li><a class='dropdown-item' href='#' role='menuitem' aria-label='" + copyLinkAriaLabel + "' data-id='" + dagsordenpunkt.Id + "' data-type='kopier_punkt'>" + copyLink + "</a></li>" + "</ul >" + "</span>" + "<span class='expand'>" + "<span class='glyphicon glyphicon-plus' aria-hidden='true'></span>" + "</span>" + "</div>" + "</div>" + "</td>";

        dagsordenpunktTemplate += punktNr + overskriftOgdetails + dropdownOgExpand + "</tr>";
    });

    if (dagsorden.Lydfiler != null && dagsorden.Lydfiler.length > 0) {
        dagsordenpunktTemplate += "<tr><td></td><td><h4>" + localization.getText("Additional_Audio_Files") + "</h4>" + modellerLydfil(dagsorden.Lydfiler) + "</td><td></td></tr>";
    }

    $(".dagsorden > tbody").html(dagsordenpunktTemplate);

    $('.details p span:has(img)').css({"display": "block", "overflow": "auto"});
    document.scanForPdfNotes(searchTerm);
    observeAndHighlightTextLayer(searchTerm);

    let focusedItems = [];
    let highlightedEnclosures = [];

    if (sharedItemId) {
        focusItem(sharedItemId, true);
    }

    $.each(dagsorden.Moede.ElasticSearchResults, (resultIndex, searchResult) => {
        const isEnclosure = searchResult.Type === "Enclosure" || searchResult.Type === "Bilag";

        if (isEnclosure && !highlightedEnclosures.find(he => he === searchResult.DocumentUid)) {
            highlightEnclosure(searchResult.DocumentUid);
            highlightedEnclosures.push(searchResult.DocumentUid);
        }

        if (!focusedItems.find(fa => fa === searchResult.AgendaItemUid) && sharedItemId === undefined) {
            focusItem(searchResult.AgendaItemUid, focusedItems.length === 0);
            focusedItems.push(searchResult.AgendaItemUid);
        }
    });
}

const highlightEnclosure = (enclosureId) => {
    const enclosure = $(`#enclosure-${enclosureId}`)[0];
    enclosure.innerHTML = `<mark>${enclosure.innerHTML}</mark>`;
}

function modellerBilag(bilag, titel) {
    var bilagMarkup = "";

    if (!bilag || bilag.length === 0) {
        return bilagMarkup;
    }

    var appendix = localization.getText("Localization_js_Appendix");

    bilagMarkup += "<h3>" + appendix + "</h3><ul class='list-unstyled'>";

    $.each(bilag, function (i, bilagValue) {
        var bilagTemplate = `<li>`;
        if (bilagValue.HarPdfVersion) bilagTemplate += `<span class='label label-default pdf-label' tabindex=0 data-type='bilag' data-id='${bilagValue.Id}' role='button' aria-label='${bilagValue.Navn}. ${localization.getText("Meeting_For_The_Item")}: ${titel}'>PDF</span>`;

        bilagTemplate += `<a id="enclosure-${bilagValue.Id}" class='bilag-link' target='_blank' href='/vis/pdf/bilag/${bilagValue.Id}/?redirectDirectlyToPdf=${isIDevice()}'>${bilagValue.Navn}</a></li>`;


        bilagMarkup += bilagTemplate;
    });

    return bilagMarkup;
}

function modellerLydfil(lydfiler) {
    var lydfilMarkup = "";

    if (!lydfiler || lydfiler.length === 0) return lydfilMarkup;

    lydfilMarkup += "<ul class='list-unstyled'>";

    $.each(lydfiler, function (i, lydfil) {
        var bilagTemplate = "<li class='lydfil-li'>";
        bilagTemplate += "<audio controls class='lydfil'>" + "<source src='" + lydfil.Filepath + "' type='audio/mpeg' > " + "</audio>" + "<p class='lydfilnavn' >" + lydfil.Filename + "</p>" + "</li>";

        lydfilMarkup += bilagTemplate;
    });

    return lydfilMarkup;
}

function modellerAbsentAttendees(attendees) {

    if (attendees) {
        var absentAttendees = attendees.filter(function (attendee) {
            return attendee.AttendanceType === "Absent";
        });

        if (absentAttendees && absentAttendees.length > 0) {
            var absentAttendeesTemplate = "<div><h3>" + localization.getText("Meeting_Absent_Attendees") + "</h3>";

            $.each(absentAttendees, function (i, attendee) {
                absentAttendeesTemplate += "<span>" + attendee.Name + "</span><br/>"
            });

            absentAttendeesTemplate += "</div>";

            return absentAttendeesTemplate;
        }
    }

    return "";
}

function modellerCancelledAttendees(attendees) {
    if (attendees) {
        var cancelledAttendees = attendees.filter(function (attendee) {
            return attendee.AttendanceType === "Cancellation";
        });

        if (cancelledAttendees && cancelledAttendees.length > 0) {
            var cancelledAttendeesTemplate = "<div><h3>" + localization.getText("Meeting_Participation_Cancelled") + "</h3>";

            $.each(cancelledAttendees, function (i, attendee) {
                cancelledAttendeesTemplate += "<span>" + attendee.Name + "</span><br/>"
            });

            cancelledAttendeesTemplate += "</div>";

            return cancelledAttendeesTemplate;
        }
    }
    ;

    return "";
}

function modellerLydfilerOgBilagOverskrift(lydfiler, bilag) {
    var lydfilMarkup = "";

    if (lydfiler && lydfiler.length > 0) {
        lydfilMarkup += "<span class='badge fil-ikon'> <span class='glyphicon glyphicon-volume-up'></span><span class='fil-ikon-nummer'>" + lydfiler.length + "</span></span>";
    }

    if (bilag && bilag.length > 0) {
        lydfilMarkup += "<span class='badge fil-ikon'><span class='glyphicon glyphicon-paperclip'></span><span class='fil-ikon-nummer'>" + bilag.length + "</span></span>";
    }

    return lydfilMarkup;
}

function modellerFelter(felter, ressourcer, ord) {
    var felterMarkup = "";

    var hasMatch = false;

    $.each(felter, function (i, felt) {

        var feltTemplate = "<h3>" + felt.Navn + "</h3>";
        var filtreretHtml = filtrerHtml(felt.Html, ord);

        felt.Html = filtreretHtml;

        if (felt.Html.indexOf("<mark") >= 0) {
            hasMatch = true;
        }

        if (felt.Html) {
            feltTemplate += felt.Html;
        } else if (felt.Link) {
            feltTemplate += `<div id="pdf-link${felt.DocumentId}"><div><a href="${felt.Link}?redirectDirectlyToPdf=${isIDevice()}" target="_blank">${localization.getText("Localization_js_Link_To_Item_Pdf")}</a></div><div class="pdfViewer" style="position: relative" data-document-id="${felt.DocumentId}" data-pdf-url="/Pdf/HentEksternPdf?documentId=${felt.DocumentId}"><div class='pdf-spinner-container'><div class="spinner center" aria-label="${localization.getText("Localization_js_Pdf_Getting_Content_Aria")}"><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div><div class="spinner-blade"></div></div></div><div class="pdfContent" aria-label='${localization.getText("Localization_js_Pdf_Picture_Presentation_Aria")}'></div></div></div>`;
        }

        felterMarkup += feltTemplate;
    });

    return {
        FelterHtml: felterMarkup, HasMatch: hasMatch
    }
}

const observeAndHighlightTextLayer = (searchParameters) => {
    const pdfContentObserver = new MutationObserver((mutations) => {
        for (let index = 0; index < mutations.length; index++) {
            for (let newNode = 0; newNode < mutations[index].addedNodes.length; newNode++) {
                const addedNode = mutations[index].addedNodes[newNode];

                if (addedNode.classList && addedNode.classList.contains('textLayer')) {
                    observeTextLayerChildren(addedNode, searchParameters);
                }
            }
        }
    });

    $(".pdfContent").each((index, pdfContent) => {
        pdfContentObserver.observe(pdfContent, {
            childList: true
        });
    });
}

const observeTextLayerChildren = (textLayer, searchParameters) => {
    const childObserver = new MutationObserver((mutations) => {
        for (let index = 0; index < mutations.length; index++) {
            for (let newNode = 0; newNode < mutations[index].addedNodes.length; newNode++) {
                const addedNode = mutations[index].addedNodes[newNode];
                const searchHighlight = highlightWithSearchParameters(searchParameters, addedNode.innerHTML);

                if (searchHighlight.hasMatch) {
                    addedNode.innerHTML = searchHighlight.newHtml;
                }
            }
        }
    });

    childObserver.observe(textLayer, {
        childList: true
    });
};

function modellerMoededeltagere(moededeltagere, dagsordenpunkter) {
    if (moededeltagere == null || moededeltagere.length === 0) {
        return;
    }

    $("#deltager-container").show();

    var moededeltagereMapped = moededeltagere.map(function (m) {

        var moedeDeltagerText = m.Name;

        var isAbsent = m.Absent || m.AttendanceType === 2;
        if (isAbsent) {
            moedeDeltagerText += " (" + localization.getText("Meeting_Absent") + ")";
        }
        var isparticipationCancelled = m.ParticipationCancelled || m.AttendanceType === 3;
        if (isparticipationCancelled) {
            moedeDeltagerText += " (" + localization.getText("Meeting_Participation_Cancelled") + ")";
        }
        // Matches the participants by name until Prepare sends ids
        var absentParticipants = dagsordenpunkter.map(function (p) {
            var attendance = p.ExternalAgendaItemAttendees
                .find(function (a) {
                    return a.Name === m.Name && a.AttendanceType > 1;
                });
            return {itemNumber: p.Number, AttendanceType: attendance ? attendance.AttendanceType : null};
        })
            .filter(function (p) {
                return !!p.AttendanceType
            });

        if (absentParticipants.length > 0) {
            var itemsWhereAbsent = absentParticipants.filter(function (p) {
                return p.AttendanceType === 2 || p.AttendanceType === 3
            });
            if (itemsWhereAbsent.length > 0) {
                moedeDeltagerText += " (" + localization.getText("Localization_js_did_not_participate_on_item") + ": ";
                itemsWhereAbsent.map(function (i, index) {
                    moedeDeltagerText += (index === 0 ? "" : ", ") + i.itemNumber;
                })
                moedeDeltagerText += ")";
            }
        }
        return moedeDeltagerText;
    });

    var nameArray = [];
    var characterLimit = 70;

    jQuery.each(moededeltagereMapped, function (i, val) {
        if (nameArray.join(", ").length + val.length < characterLimit) {
            nameArray.push(val);
        }
    });

    var deltagere = $(".deltagere");
    deltagere.append(nameArray.join(", "));

    if (moededeltagereMapped.length > nameArray.length) {
        var deltagerRest = moededeltagereMapped.length - nameArray.length;
        deltagere.append(' ' + Localization.getText("Common_And") + ' ' + deltagerRest + localization.getText("Localization_js_Participants_And_More"));
        deltagere.append(' <a id="deltager-link" tabindex="0" aria-label="' + localization.getText("Localization_js_View_All_Participants") + '">' + '(' + localization.getText("Localization_js_View_All") + ')</a>');
    }

    $("#deltager-link").off("click").on("click", function () {
        openParticipantsModal(moededeltagereMapped)
    });

    $("#deltager-link").keypress(function (e) {
        if (e.which == 13) {
            openParticipantsModal(moededeltagereMapped);
        }
    });
}

function openParticipantsModal(moededeltagereMapped) {
    $(".deltager-modal-body").html("");
    jQuery.each(moededeltagereMapped, function (i, val) {
        $(".deltager-modal-body").append('<p>' + val + '</p>');
    });
    $(".deltager-modal-title").html(moededeltagereMapped.length + localization.getText("Localization_js_Participants"));
    $("#deltager-modal").modal().show();
}

function filtrerHtml(html, ord) {

    var outputHtml = "";

    var domParser = new DOMParser();
    var parsedHtml = domParser.parseFromString(html, "text/html");

    if (!parsedHtml || !parsedHtml.body) return outputHtml;

    var virtualDom = $.parseHTML(parsedHtml.body.innerHTML);

    $.each(virtualDom, function (index, element) {
        var htmlNodeIterator = new HtmlNodeIterator(ord);

        htmlNodeIterator.iterate(element);

        if (element.outerHTML) {
            outputHtml += element.outerHTML;
        }
    });

    return outputHtml;
}

function HtmlNodeIterator(ord) {

    this.iterate = function iterate(node) {
        var elementNodeType = 1;

        if (!node || node.nodeType !== elementNodeType) return;

        for (var i = 0; i < node.childNodes.length; i++) {
            var childNode = node.childNodes[i];
            this.iterate(childNode);
        }
        if (ord !== undefined) {
            $(node).highlight(ord);
        }

    }
}

const highlightWithSearchParameters = (searchParameters, html) => {
    const searchResult = {
        newHtml: html, hasMatch: false
    };

    if (!searchParameters) {
        return searchResult;
    }

    $.each(searchParameters, (index, searchParameter) => {
        const regEx = new RegExp(searchParameter, "ig");

        if (!html) {
            return true;
        }

        const matches = html.match(regEx);

        if (matches) {
            searchResult.newHtml = searchResult.newHtml.replace(regEx, "<mark>" + matches[0] + "</mark>");

            if (!searchResult.hasMatch) {
                searchResult.hasMatch = true;
            }
        }
    });

    return searchResult;
}

function focusItem(itemId, scrollToItem = true) {
    const itemRowElement = $("#punktrow_" + itemId);
    if (!itemRowElement) return;

    new RowElement(itemRowElement).toggleDisplay();

    if (scrollToItem) {
        $('html,body').animate({scrollTop: itemRowElement.offset().top});
    }
}

function initExpand() {
    var toggleDetails = function (e) {
        if (e.type === "keydown" && !enterOrSpacePressed(e)) {
            return;
        }
        var target = $(e.target);

        // Hvis eventet kommer fra esc, naar dropdown lukkes
        if (target.hasClass("dropdown-toggle") || target.hasClass("dropdown-menu")) return;

        // Hvis det ikke er direkte på tr-elementet, skal
        if (target.closest("div.details:visible").length > 0) {
            return;
        }
        var rowElement = new RowElement($(this));
        rowElement.toggleDisplay();

        return false;
    };

    var tableRow = $("table.dagsorden tr");
    tableRow.off("click.toggleDetails").on("click.toggleDetails", toggleDetails);
    tableRow.off("keydown.toggleDetails").on("keydown.toggleDetails", toggleDetails);
}

var RowElement = function (elm) {
    this.elm = elm;

    this.toggleDisplay = function () {
        var me = this.elm;
        var isHidden = me.hasClass("isHidden");
        var isVisible = me.hasClass("isVisible");
        var glyphicon = me.find("td:last .expand .glyphicon");
        if (isHidden || !isVisible) {
            me.find("td > .details").slideDown();
            me.addClass("isVisible");
            me.removeClass("isHidden");

            glyphicon.addClass("glyphicon-minus");
            glyphicon.removeClass("glyphicon-plus");

            me.find(".overskrift-btn")[0].setAttribute("aria-expanded", "true");

        } else {
            me.find("td > .details").slideUp();
            me.addClass("isHidden");
            me.removeClass("isVisible");

            glyphicon.addClass("glyphicon-plus");
            glyphicon.removeClass("glyphicon-minus");

            me.find(".overskrift-btn")[0].setAttribute("aria-expanded", "false");
        }
    };
};

var SendEmailDialogHandler = function (url, punktId, dialog, sendbutton, reader, captchaHandler) {
    this.dialog = dialog;
    this.punktId = punktId;
    this.url = url;
    this.button = sendbutton;
    this.originalButtonText = sendbutton.text();
    this.hashReader = reader;
    this.captchaHandler = captchaHandler;

    this.fire = function (successFunction, failFunction) {

        var isValid = this.validateData();
        if (!isValid) return;

        this.toggleButton(false);

        var dagsordenId = this.hashReader.getDagsordenId();
        var data = {"punktId": this.punktId, "DagsordenId": dagsordenId};
        data.CaptchaCode = this.captchaHandler.getResponse();
        data = this.appendInputValues(data);

        this.sendEmail(data, successFunction, failFunction);
    };

    this.toggleButton = function (enabled) {
        if (enabled) {
            this.button.text(this.originalButtonText);
            this.button.prop("disabled", false);
        } else {
            this.button.text(localization.getText("Localization_js_Sending_Please_Wait"));
            this.button.prop("disabled", true);
        }
    };

    this.appendInputValues = function (data) {
        var inputElements = this.dialog.find(".form-control");
        inputElements.each(function (index) {
            var elm = $(inputElements[index]);
            data[elm.attr("name")] = elm.val();
        });
        return data;
    };

    this.validateData = function () {
        var inputElements = this.dialog.find(".form-control");
        var invalid = false;
        inputElements.each(function (index) {
            var elm = $(inputElements[index]);
            var parent = elm.parent();
            var elementValue = elm.val();
            if (!elementValue || elementValue.trim() == "") {
                parent.addClass("has-error");
                parent.find('.validationError').show();
                invalid = true;
            } else {
                parent.find('.validationError').hide();
                parent.removeClass("has-error");
            }
        });

        if (this.captchaHandler.getResponse().trim() == '') {
            invalid = true;
            $("#captchaValidation").show();
        } else {
            $("#captchaValidation").hide();
        }

        return !invalid;
    };

    this.sendEmail = function (data, success, fail) {
        var dialog = this.dialog;
        var handler = this;
        var url = this.url;
        var captcha = this.captchaHandler;

        $.ajax({
            url: url, type: "POST", async: true, dataType: "json", data: data
        }).done(function (result) {
            if (result.Success) {
                dialog.modal('hide');
                success();
            } else fail(result.ErrorMessage);
        }).fail(function (obj, status, errorThrown) {
            fail(localization.getText("Localization_js_Sending_Failed"));
        }).always(function () {
            handler.toggleButton(true);
            captchaHandler.reset();
        });
    };

    this.show = function () {
        this.resetDialogValues();
        this.dialog.modal('show');
    };

    this.resetDialogValues = function () {
        var inputElements = this.dialog.find(".form-control");
        inputElements.each(function (index) {
            var elm = $(inputElements[index]);
            var parent = elm.parent();
            elm.val("");
            parent.removeClass("has-error");
            parent.find('.validationError').hide();
        });

        $("#captchaValidation").hide();
        var hasBeenRendered = this.dialog.find("#captchaElement").children().length > 0;
        if (hasBeenRendered) this.captchaHandler.reset(); else {
            this.captchaHandler.render("captchaElement", {
                "sitekey": "6LeoXDQUAAAAABDPY8J3gHtNKQjn5xyHzoCtHFgv"
            });
        }
    };
};

var QueryReader = function (hash, search) {

    this.parse = function (hash) {
        var map = {};
        if (hash.trim().length <= 0) return map;
        hash = hash.substring(1);
        var split = hash.split("&");
        for (var i = 0; i < split.length; i++) {
            var keyvalue = split[i].split("=");
            if (keyvalue.length > 1) map[keyvalue[0]] = decodeURIComponent(keyvalue[1]); else map["id"] = keyvalue[0];
        }
        return map;
    };


    if (hash) this.hashMap = this.parse(hash); else this.hashMap = this.parse(search);

    this.getPunktId = function () {
        return this.hashMap["punktid"];
    };

    this.getSearchTerm = function () {
        var fritekst = this.hashMap["fritekst"];
        if (fritekst) return fritekst.split(" ");
        return fritekst;
    };

    function isDagsordenKey(hashMap, key) {
        return key === "id";
    }

    this.getDagsordenId = function () {
        for (var key in this.hashMap) {
            if (isDagsordenKey(this.hashMap, key)) return this.hashMap[key];
        }
        return null;
    };

    this.setPunktId = function (id) {
        this.hashMap["punktid"] = id;
    };

    function queryKeyValues(hashMap) {
        var hash = "?";
        for (var key in hashMap) {
            hash += key + "=" + hashMap[key] + "&";
        }
        return hash.slice(0, -1);
    }

    this.getQueryString = function () {
        return queryKeyValues(this.hashMap);
    }
};


// Highlight - Taget fra https://stackoverflow.com/questions/119441/highlight-a-word-with-jquery

jQuery.extend({
    highlight: function (node, re, nodeName, className) {
        if (node.nodeType === 3) {
            var match = node.data.match(re);
            if (match) {
                var highlight = document.createElement(nodeName || 'span');
                highlight.className = className || 'highlight';
                var wordNode = node.splitText(match.index);
                wordNode.splitText(match[0].length);
                var wordClone = wordNode.cloneNode(true);
                highlight.appendChild(wordClone);
                wordNode.parentNode.replaceChild(highlight, wordNode);
                return 1; //skip added node in parent
            }
        } else if ((node.nodeType === 1 && node.childNodes) && // only element nodes that have children
            !/(script|style)/i.test(node.tagName) && // ignore script and style nodes
            !(node.tagName === nodeName.toUpperCase() && node.className === className)) { // skip if already highlighted
            for (var i = 0; i < node.childNodes.length; i++) {
                i += jQuery.highlight(node.childNodes[i], re, nodeName, className);
            }
        }
        return 0;
    }
});

jQuery.fn.unhighlight = function (options) {
    var settings = {className: 'highlight', element: 'span'};
    jQuery.extend(settings, options);

    return this.find(settings.element + "." + settings.className).each(function () {
        var parent = this.parentNode;
        parent.replaceChild(this.firstChild, this);
        parent.normalize();
    }).end();
};

jQuery.fn.highlight = function (words, options) {
    var settings = {className: 'highlight', element: 'mark', caseSensitive: false, wordsOnly: false};
    jQuery.extend(settings, options);

    if (words.constructor === String) {
        words = [words];
    }
    words = jQuery.grep(words, function (word, i) {
        return word != '';
    });
    words = jQuery.map(words, function (word, i) {
        return word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    });
    if (words.length == 0) {
        return this;
    }
    ;

    var flag = settings.caseSensitive ? "" : "i";
    var pattern = "(" + words.join("|") + ")";
    if (settings.wordsOnly) {
        pattern = "\\b" + pattern + "\\b";
    }
    var re = new RegExp(pattern, flag);

    return this.each(function () {
        jQuery.highlight(this, re, settings.element, settings.className);
    });
};



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/vis.js
// module id = 0
// module chunks = 4